import axios from "axios";
import { settings } from "../../main/configs/settings";
import ICNPJInformation from "../../domain/models/integration-cnpj";



export class HelperCnpjInformaton {
  static async getInformationCnpj(cnpj: string): Promise<Partial<ICNPJInformation> | null> {
    const baseApiUrl = `${settings.API_URL}/public/integration/check-cnpj/${cnpj}`;

    try {
      const response = await axios.get(baseApiUrl);
      const {
        situacao,
        telefone,
        status,
        socios,
        email,
        tipo,
        cached,
        endereco,
        fantasia,
        atividades,
        data_situacao,
        ultima_atualizacao,
        natureza_juridica,
        cpf_cnpj,
        capital_social,
        abertura,
        razao_social
      } = response.data;

      return {
        situacao,
        telefone,
        status,
        socios,
        email,
        tipo,
        cached,
        endereco,
        nome: fantasia || "",
        atividades,
        data_situacao,
        ultima_atualizacao,
        natureza_juridica,
        cpf_cnpj,
        capital_social,
        data_abertura: abertura || "",
        razao_social
      };

    } catch (error) {
      return {
        situacao: "",
        telefone: "",
        status: "",
        socios: [],
        email: "",
        tipo: "",
        cached: false,
        endereco: {
          uf: "",
          complemento: "",
          numero: "",
          logradouro: "",
          bairro: "",
          municipio: "",
          cep: ""
        },
        nome: "",
        atividades: [],
        data_situacao: "",
        ultima_atualizacao: "",
        natureza_juridica: "",
        cpf_cnpj: "",
        capital_social: "",
        data_abertura: "",
        razao_social: ""
      };
    }
  }

  static isValidCnpj = (inputCnpj: string): boolean => {
    const WEIGHTS_FIRST_DIGIT = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const WEIGHTS_SECOND_DIGIT = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const cnpj = inputCnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
    if (cnpj.length !== 14) return false;

    const base = cnpj.substring(0, 12);
    const dvs = cnpj.substring(12);

    if (!/^[0-9A-Z]{12}$/.test(base)) return false;
    if (!/^\d{2}$/.test(dvs)) return false;

    if (/^(.)\1{11}$/.test(base)) return false;

    const charToValue = (char: string): number => char.charCodeAt(0) - 48;

    const calculateDigit = (source: string, weights: number[]): number => {
      let sum = 0;
      for (let i = 0; i < source.length; i += 1) {
        sum += charToValue(source.charAt(i)) * weights[i];
      }
      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };

    const firstDigit = calculateDigit(base, WEIGHTS_FIRST_DIGIT);
    if (firstDigit !== parseInt(dvs.charAt(0), 10)) return false;

    const secondDigit = calculateDigit(base + firstDigit, WEIGHTS_SECOND_DIGIT);
    return secondDigit === parseInt(dvs.charAt(1), 10);
  };

}

export default HelperCnpjInformaton;
